// Owner: workflow-canvas (plan §9.33, §4.2). Keys of the automations list: Esc clears the selection while
// rows are selected (an open menu or dialog takes Esc first, it sits above the list in the layer stack).
import { defineCommand, defineScope } from '@dataroom/interaction';
import { defineAppCommands } from '../../extensions/commands';
import { t } from '../../lib/i18n';

export type WorkflowListContext = { hasSelection: () => boolean; clearSelection: () => void };

export const workflowListScope = defineScope<WorkflowListContext>({
  id: 'workflow.list',
  kind: 'list',
  title: () => t('wf.title'),
});

export default defineAppCommands({
  id: 'workflows.list',
  loadTitles: () => import('./messages'),
  scopes: [workflowListScope],
  commands: [
    defineCommand<WorkflowListContext>({
      id: 'workflow.list.clearSelection',
      title: () => t('wc.list.clearSelection'),
      shortcut: 'escape',
      scope: workflowListScope,
      when: (c) => c.hasSelection(),
      run: (c) => c.clearSelection(),
    }),
  ],
});
